// For use on FeatureComparison table  2023 - Q4

import React from 'react';
import { Color, setColor } from 'app_previous/styles/colors';

interface IconProps {
  color?: Color;
}

export const Checkmark = ({ color = 'greyText' }: IconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='25'
    viewBox='0 0 25 24'
    fill='none'
  >
    <path
      d='M11.5156 15.5625C11.2344 15.8438 10.7188 15.8438 10.4375 15.5625L7.4375 12.5625C7.15625 12.2812 7.15625 11.7656 7.4375 11.4844C7.71875 11.2031 8.23438 11.2031 8.51562 11.4844L11 13.9688L16.4375 8.48438C16.7188 8.20312 17.2344 8.20312 17.5156 8.48438C17.7969 8.76562 17.7969 9.28125 17.5156 9.5625L11.5156 15.5625ZM24.5 12C24.5 18.6562 19.1094 24 12.5 24C5.84375 24 0.5 18.6562 0.5 12C0.5 5.39062 5.84375 0 12.5 0C19.1094 0 24.5 5.39062 24.5 12ZM12.5 1.5C6.6875 1.5 2 6.23438 2 12C2 17.8125 6.6875 22.5 12.5 22.5C18.2656 22.5 23 17.8125 23 12C23 6.23438 18.2656 1.5 12.5 1.5Z'
      fill={setColor(color)}
    />
  </svg>
);

export const UnCheckmark = ({ color = 'greyText' }: IconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='15'
    height='20'
    viewBox='0 0 15 2'
    fill='none'
  >
    <path
      d='M15 1C15 1.42188 14.625 1.75 14.25 1.75H0.75C0.328125 1.75 0 1.42188 0 1C0 0.625 0.328125 0.25 0.75 0.25H14.25C14.625 0.25 15 0.625 15 1Z'
      fill={setColor(color)}
    />
  </svg>
);

export const CrossMark = ({ color = 'greyText' }: IconProps): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    viewBox='0 0 24 25'
    fill='none'
  >
    <path
      d='M12 0.875C18.4219 0.875 23.625 6.07812 23.625 12.5C23.625 18.9219 18.4219 24.125 12 24.125C5.57812 24.125 0.375 18.9219 0.375 12.5C0.375 6.07812 5.57812 0.875 12 0.875ZM12 21.875C17.1562 21.875 21.375 17.7031 21.375 12.5C21.375 7.34375 17.1562 3.125 12 3.125C6.79688 3.125 2.625 7.34375 2.625 12.5C2.625 17.7031 6.79688 21.875 12 21.875ZM16.7344 9.59375L13.8281 12.5L16.7344 15.4531C16.9688 15.6406 16.9688 16.0156 16.7344 16.25L15.7031 17.2812C15.4688 17.5156 15.0938 17.5156 14.9062 17.2812L12 14.375L9.04688 17.2812C8.85938 17.5156 8.48438 17.5156 8.25 17.2812L7.21875 16.25C6.98438 16.0156 6.98438 15.6406 7.21875 15.4531L10.125 12.5L7.21875 9.59375C6.98438 9.40625 6.98438 9.03125 7.21875 8.79688L8.25 7.76562C8.48438 7.53125 8.85938 7.53125 9.04688 7.76562L12 10.6719L14.9062 7.76562C15.0938 7.53125 15.4688 7.53125 15.7031 7.76562L16.7344 8.79688C16.9688 9.03125 16.9688 9.40625 16.7344 9.59375Z'
      fill={setColor(color)}
    />
  </svg>
);
